import { useEffect, useState } from "react";
const usePayByApplePayExist = () => {
  const [isApplePayAvailable, setIsApplePayAvailable] = useState(false);

  useEffect(() => {
    if (window.ApplePaySession && ApplePaySession.canMakePayments) {
      setIsApplePayAvailable(true);
    }
  }, []);

  return {
    isApplePayAvailable,
  };
};

export default usePayByApplePayExist;
